module.exports = require("./mn.d.ts");